import React, { useState, useEffect } from 'react';

import FooterLayoutComponent from '../common/layout/FooterLayoutComponent';
import LnbComponent from './LnbComponent';
import SustainabilityModalPopupComponent from './SustainabilityModalPopupComponent';

const SustainabilityComponent = props => {
    const [isOpenedPopup, setIsOpenedPopup] = useState(false);

    const onClickBtnShowPopup = evt => {
        setIsOpenedPopup(true);
        document.body.style.position = 'fixed';
        document.body.style.overflow = 'hidden';
    }
    const onClickBtnClosePopup = evt => {
        setIsOpenedPopup(false);
        document.body.style.position = 'relative';
        document.body.style.overflow = 'auto';
    }

    return (
        <main className="about">
            <div className="body">
                <div className="head">
                    <div className="title">
                        SUSTAINABILITY
                    </div>
                    <LnbComponent
                        tabIdx={1}
                        {...props}
                    />
                </div>
                <section class="intro-t1 l sust">
                    <div class="img"><img src="/imgs/aboutTCE_SUSTAINABILITY_1.png" alt="recycle" /></div>
                    <div class='title mb'>
                        <h3 class="text">RECYCLE</h3>
                        <div class="divider"></div>
                    </div>
                    <div class="info">
                        <h3 class="title">RECYCLE</h3>
                        <div class="divider"></div>
                        <p class="desc">Nature, which is constantly circulating the energy of our planets life, is
                            our greatest teacher. In order to recycle the water we use; a high-level reprocessing
                            facility treats wastewater and recycles it into a production process water. Recycled
                            disposable materials for denim production helps to save the global environment and low
                            environmental damage.</p>
                    </div>
                </section>
                <section class="intro-t1 l sust">
                    <div class="img"><img src="/imgs/aboutTCE_SUSTAINABILITY_2.png" alt="recycle" /></div>
                    <div class='title mb'>
                        <h3 class="text">REDUCE</h3>
                        <div class="divider"></div>
                    </div>
                    <div class="info">
                        <h3 class="title">REDUCE</h3>
                        <div class="divider"></div>
                        <p class="desc">Its believed that denim requires the use of a large amount of water and
                            chemicals to process. Developing sustainable TCEs technologies changes these
                            stereotypes. Laser washing and ozone treatment during the washing process reduce the
                            amount of water and chemicals used. Less Water Dyeing technology can save water through
                            sustainable dyestuffs. Saving on energy, water, and greenhouse gas emissions is possible
                            through developing sustainable technologies.</p>
                    </div>
                </section>
                <section class="intro-t1 l sust">
                    <div class="img"><img src="/imgs/aboutTCE_SUSTAINABILITY_3.png" alt="recycle" /></div>
                    <div class='title mb'>
                        <h3 class="text">REUSE</h3>
                        <div class="divider"></div>
                    </div>
                    <div class="info">
                        <h3 class="title">REUSE</h3>
                        <div class="divider"></div>
                        <p class="desc">Reuse gives a new and powerful value to used resources and energy. Reuse is
                            not a linear economy that ends after using and discarding resources but focuses on
                            reusing resources to reuse them through a circular economy. For creating new value from
                            existing abandoned resources and energy, we reuse residual heat, steam, and cooling
                            water. These reuse systems are made possible by TCEs refined sustainable technology.
                        </p>
                    </div>
                </section>
                <section class="intro-t1 l sust">
                    <div class="img"><img src="/imgs/aboutTCE_SUSTAINABILITY_4.png" alt="recycle" /></div>
                    <div class='title mb'>
                        <h3 class="text">RESPONSIBILITY</h3>
                        <div class="divider"></div>
                    </div>
                    <div class="info">
                        <h3 class="title">RESPONSIBILITY</h3>
                        <div class="divider"></div>
                        <p class="desc">Denim is fabric and clothing for all people. So, denim should be produced
                            based on a love of humanity and a respect for human life and spirit. To bring the warmth
                            of humanity to denim, we donate scholarships and teach tools to schools in the
                            communities surrounding our denim factories. Employees are also working in a cleaner,
                            safer environment and make healthy working conditions that will grow with company.</p>
                    </div>
                </section>
                <div class="divider"></div>
                <section class="intro-f sust">
                    <h2>SUSTAINABLE PRODUCTS</h2>
                    <div class="info">
                        <p class="desc">TCE produce completely sustainable denim. TCEs denims are made from more
                            sustainable materials such as organic cotton, recycled yarns, etc. We are proud of the
                            process of re-creating and upcycling what was once abandoned in our lives into wonderful
                            denim. These products are not only low damaged to environmental but also fully
                            functional.</p>
                        <div class="img"><img src="/imgs/aboutTCE_SUSTAINABILITY_5.png" alt="Sustainable Products" /></div>
                        <div class='img-mb'><img src='/imgs/m_aboutTCE_SUSTAINABILITY_5.png' alt="Sustainable Products" /></div>
                        <div class="controller">
                            <button class="btn btn-more"
                                onClick={evt => onClickBtnShowPopup(evt)}>VIEW MORE</button>
                        </div>
                    </div>
                </section>
                <div className="divider"></div>
                <section className="intro-f sust">
                    <h2>CERTIFICATION</h2>
                    <div className="info">
                        <p className="desc">World-class certificates for production processes.</p>
                        <div className="cert-list">
                            <ul>
                                <li>
                                    <dl>
                                        <dt>Recycle : </dt>
                                        <dd>GRS(Global Recycled Standard), RCS(Recycled Claim Standard)</dd>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <div
                                                        className="img recycle-1"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_6.png"
                                                            alt="Recycle"
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="img recycle-3"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_8.png"
                                                            alt="Recycle"
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </li>
                                <li>
                                    <dl>
                                        <dt><strong>Sustainability</strong> : HIGG INDEX, OEKO TEX
														<br/>
										<strong>COTTON :</strong>
														GOTS(Global Organic Textile Standard), OCS(Organic Content Standard)</dt>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <div
                                                        className="img sust-1"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_9.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="img sust-3"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_11.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="img sust-4"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_12.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="img sust-5"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_13.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </li>
                                <li>
                                    <dl>
                                        <dt>COTTON : </dt>
                                        <dd>
											BCI, COTTON LEAD, COTTON USA, E3 COTTON
                                        </dd>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <div
                                                        className="img cotton-1"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_14.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="img cotton-2"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_15.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="img cotton-3"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_16.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </li>
                                <li>
                                    <dl>
                                        <dt>
                                           COMPLIANCE AND MANAGEMENT PROCESS :
                                        </dt>
                                        <dd>
                                           ISO9001, ISO14001, WRAP GOLD LEVEL, BSCI, MQP(Mill Qualification program), C-TPAT, SLCP(COCIAL LABOR CONVERNGENCE), BETTER WORK, GSV(GLOBAL SECURITY VERTIFICATION)
                                        </dd>
                                        <dd>
                                            <ul>
                                                <li>
                                                    <div
                                                        className="img comp-1"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_17.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="img comp-2"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_18.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="img comp-3"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_19.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="img comp-4"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_20.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li>
                                                    <div
                                                        className="img comp-5"
                                                    >
                                                        <img
                                                            src="/imgs/aboutTCE_SUSTAINABILITY_21.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li class='mb'>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li class='mb'>
                                                    <div
                                                        className="img comp-6"
                                                    >
                                                        <img
                                                            src="/imgs/SLCP_x2.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li class='mb'>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li class='mb'>
                                                    <div
                                                        className="img comp-7"
                                                    >
                                                        <img
                                                            src="/imgs/GSV_Logo_Web_x2.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li class='mb'>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li class='mb'>
                                                    <div
                                                        className="img comp-8"
                                                    >
                                                        <img
                                                            src="/imgs/BETTER_WORK_x2.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                            <ul>
                                                <li class='pc'>
                                                    <div
                                                        className="img comp-6"
                                                    >
                                                        <img
                                                            src="/imgs/SLCP_x2.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li class='pc'>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li class='pc'>
                                                    <div
                                                        className="img comp-7"
                                                    >
                                                        <img
                                                            src="/imgs/GSV_Logo_Web_x2.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                                <li class='pc'>
                                                    <div
                                                        className="divider"
                                                    ></div>
                                                </li>
                                                <li class='pc'>
                                                    <div
                                                        className="img comp-8"
                                                    >
                                                        <img
                                                            src="/imgs/BETTER_WORK_x2.png"
                                                            alt="Sustainability"
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                        </dd>
                                    </dl>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
            </div>
            <FooterLayoutComponent
                {...props} />
            <SustainabilityModalPopupComponent
                isOpenedPopup={isOpenedPopup}
                onClickBtnClosePopup={onClickBtnClosePopup}
                {...props} />
        </main>
    )
}

export default SustainabilityComponent;